import React, { memo } from 'react'
import { Card } from 'transfix-ui/components/Card'
import { ISpotBiddingRule } from '../types/spotBiddingConfig'
import { SpotBiddingRulesTable } from './SpotBiddingRulesTable'

interface IBaselineRulesCardProps {
  baselineRule?: ISpotBiddingRule
  globalBaselineRule?: ISpotBiddingRule
}

export const BaselineRulesCard = memo<IBaselineRulesCardProps>(
  ({ baselineRule, globalBaselineRule }) => {
    return (
      <Card>
        <h3 className='heading-medium'>Baseline Rules</h3>
        <hr />
        <SpotBiddingRulesTable
          spotBiddingRules={baselineRule ? [baselineRule] : []}
          globalRules={globalBaselineRule ? [globalBaselineRule] : []}
          dataTest='baseline-rules-table'
        />
      </Card>
    )
  }
)
